/**
 * This function takes in a start and end time and returns the duration between the two times in minutes.
 * @param start
 * @param end 
 * @returns 
 */
export const durationBetweenTimes = (start: String | undefined, end: String | undefined, maxValidDuration: number = 180) => {
    if (!start || !end) return undefined;
    const prefix = "1970-01-01T";
    const startDate = new Date(prefix + start);
    const endDate = new Date(prefix + end);
    const minutes = (endDate.getTime() - startDate.getTime()) / 60000;

    return minutes < 0 || minutes > maxValidDuration ? undefined : minutes;
}